import { render } from "./StaffBulkUpload.vue?vue&type=template&id=492d7941&scoped=true"
import script from "./StaffBulkUpload.vue?vue&type=script&lang=js"
export * from "./StaffBulkUpload.vue?vue&type=script&lang=js"

import "./StaffBulkUpload.vue?vue&type=style&index=0&id=492d7941&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492d7941"]])

export default __exports__